import * as React from 'react';
import {Avatar, makeStyles, Tooltip} from '@material-ui/core';
import {default as ImageIcon,} from '@material-ui/icons/Image';
import {ImgAvatarStyle} from './ImgAvatar.style';



const useStyles = makeStyles(ImgAvatarStyle);

interface IProps {
  imgName: number;
  imgUrl: string|undefined;
  size?: "small" | "medium";
  border?: boolean;
  selected?: boolean;
  grayed?: boolean;
  style?: React.CSSProperties;
  color: string;
  altText?: string;
}

const ImgAvatar = (props: IProps) => {
  const classes = useStyles();
  const avatarStyle: React.CSSProperties = {
    backgroundColor: props.grayed ? '#dbdbdb' : props.color,
    ...props.style,
  };
  
  return (
    <Tooltip title={props.altText ? props.altText : ""} placement="top" >
      {props.imgName !== undefined ?
        (<div
          style={avatarStyle}
          className={`${classes.avatar} ${props.border ? classes.border : ""} ${props.selected ? classes.selected : ""} ${props.size ? classes[props.size] : ""} `}
        >
          <img
            className={`${classes.avatarImage} ${props.grayed ? classes.greyAvatarImage : ""}`}
            src={props.imgUrl?props.imgUrl:("avatars/" + props.imgName + ".png")}
          />
        </div>)
        :
        (<Avatar><ImageIcon /></Avatar>)}
    </Tooltip>
  );
};

export default ImgAvatar;



// WEBPACK FOOTER //
// ./src/components/common/avatar/ImgAvatar.tsx